export default "__VITE_ASSET__Bl3OevBQ__"